import commonHelper from '@/app/utility/common.helper.utility';
import URL_UTILITY from '../../../../utility/url.utility';
import previewDoc from '../../../onlineApproval/internalWorkFlow/history/uploadDocument/previewDoc';
// import appStrings from '@/app/utility/string.utility';
export default {
  name: 'Bank Update Details',
  components: { previewDoc },
  props: [
    'rackRowData',
    'bankUpdateDetails',
    'eventId'
  ],
  watch: {
    currentPage: function() {
      this.getVendorBankDetails();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getVendorBankDetails();
    }
  },
  data() {
    return {
      totalRows: null,
      currentPage: 1,
      loader: false,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOptionSelectedInvoice(),
      isSuccess: false,
      responseMsg: '',
      showAlert: false,
      partyReqId: null,
      eventID: null,
      approvalStatus: null,
      downloadDocUrl: URL_UTILITY.getOpenKmDocDeleteUrl,
      uploadedFileName: null,
      showOpenModal: false,
      docDtlId: null,
      authToken: null,
      openKmAuth: null,
      tempToken: null,
      dynamicData:null,
      currentPageIndex:null,
      accessButtons: {
        deleteAllow: false,
        downloadAllow: false,
        uploadAllow: false,
        editAllow: false,
        addAllow: false,
        printAllow: false,
        approvalAllow: false,
        newTab: true,
      },
      bankDocumentsModal:false,
      partyBankReqId:null,
      vendorName:null,
      accountNumber:null,
      appStatus: null,
      showValueSetModal: false,
      bankName:null,
      activeStatus:null,
      branchName:null,
      ifscCode:null,
      siteName:null,
      endDate:null,
      beneficiaryName:null,
      uuid:null,
      allFlag: false,
      approvalHistoryData: [],
      approvalHistoryFields: [
        {
          key: 'approver_name'
        },
        { key: 'approver_designation', label: 'Designation' },
        {
          key: 'action_date'
        },
        {
          key: 'seq_order',
          label: 'Approver Order'
        },
        {
          key: 'approval_status',
          label: 'Status'
        },
        {
          key: 'comments'
        }
      ],
      wfDtlId:null,
      showApproveModal:false,
      showRejectModal:false,
      approvalReason:null,
      rejectedReason:null,
      recordId:null,
      vendorCode:null,
    };
  },
  mounted() {
    if(this.rackRowData){
      this.approvalStatus=this.rackRowData.approval_status;
      this.recordId=this.rackRowData.party_bank_req_update_id;
      this.getVendorBankDetails();
    }
    else if(this.bankUpdateDetails){
      this.approvalStatus=this.bankUpdateDetails.approval_status
      this.recordId=this.bankUpdateDetails.party_bank_req_update_id;
      this.wfDtlId=this.bankUpdateDetails.wf_inprocess_dtl_id;
      this.getVendorBankDetails();
  }

  if(this.approvalStatus=="APPROVED" || this.approvalStatus=="INPROCESS"){
    this.getMenuId()
}
if(this.eventId){
  this.getHistory(this.eventId)
}
  },
  methods: {
    getVendorBankDetails() {
        const payload = {
          partyReqUpdateId:this.recordId  
        };
        this.loader = true;
        this.$store
          .dispatch('vendorUpdate/getVendorBankUpdateDataById', payload)
          .then(resp => {
            this.loader = false;
            if (resp.status === 200) {
              this.vendorName=resp.data.data.name;
              this.vendorCode=resp.data.data.vendor_code;
              this.accountNumber=resp.data.data.account_num;
              this.appStatus=resp.data.data.approval_status;
              this.bankName=resp.data.data.bank_code;
              this.activeStatus=resp.data.data.active?'Active':'Inactive';
              this.branchName=resp.data.data.branch_name;
              this.ifscCode=resp.data.data.ifsc;
              this.siteName=resp.data.data.vendor_site_code;
              this.endDate=resp.data.data.end_date;
              this.beneficiaryName=resp.data.data.beneficiary_name;
              this.uuid=resp.data.data.uuid;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      },
      getMenuId() {
        const payload = {
          event_name: this.$route.name
        };
        this.$store
          .dispatch('intWorkflow/getDynamicMenuId', payload)
          .then(response => {
            if (response.status === 200) {
              const result = response.data.data;
              if (result) {
                this.wfMenuId = result.menu_id;
                this.getEventId();
              }
            }
          });
      },
      getEventId() {
        this.$store
          .dispatch('intWorkflow/getEventId', this.wfMenuId)
          .then(response => {
            if (response.status === 200) {
              this.eventID = response.data.data;
              this.getHistory()
            }
          });
      },
      switchVariable() {
        this.allFlag = this.allFlag
          ? (this.allFlag = false)
          : this.allFlag == false
          ? (this.allFlag = true)
          : null;
        this.getHistory(this.eventId);
      },
      getHistory(id) {
        const payload = {
          eventId: this.eventID?this.eventID:id,
          nfaHdrId: this.recordId,
          approvalStatus: this.allFlag ? 'Y' : !this.allFlag ? 'N' : ''
        };
        this.loader = true;
        this.$store
          .dispatch('intWorkflow/getApprovalList', payload)
          .then(response => {
            this.loader = false;
            if (response.status === 200) {
              this.approvalHistoryData = response.data.data;
            }
          })
          .catch(() => {
            this.loader = false;
          });
      },
      showHideApproveModal(flag) {
        this.showApproveModal = flag;
      if (!flag) {
        this.approvalReason = null;
      }
    },
    showHideRejectModal(flag) {
      this.showRejectModal = flag;
      if (!flag) {
        this.rejectedReason = null;
      }
    },
    approveRejectInvoiceApproval(status) {
      const payload = {
        event_id: this.eventId,
        wf_inprocess_dtl_id: this.wfDtlId,
        notification_status: status,
        notification_comments:
          status === 'REJECTED' ? this.rejectedReason : this.approvalReason
      };
      this.loader = true;
      this.$store
        .dispatch('intWorkflow/approvalRejectSingle', payload)
        .then(response => {
          this.loader = false;
          this.showAlert = true;
          if (response.status === 200) {
            this.getVendorBankDetails();
            this.getMenuId()
            // this.editMode = false;
            this.isSuccess = true;
            this.responseMsg = response.data.message;
            if (status === 'REJECTED') {
              this.showHideRejectModal(false);
            } else if (status === 'APPROVED') {
              this.showHideApproveModal(false);
            }
          } else {
            this.showAlert = false;
            alert(response.response.data.message);
            // this.isSuccess = false;
            // this.responseMsg = response.response.data.message;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    //   openValueSetModal(vsetCode) {
    //     this.vsetCode = vsetCode;
    //     this.showValueSetModal = true;
    //     this.setTimeVsetCode = setTimeout(() => {
    //       const vSetData = {
    //         valueSetName: vsetCode,
    //         multiFlag: null
    //       };
    //       this.eventBus.$emit('valueSetCode', vSetData);
    //     }, 0);
    //   },
    //   closeValueSetModal() {
    //     this.showValueSetModal = false;
    //   },
    //   selectedvalueSet(item) {
    //     if (
    //       this.vsetCode === appStrings.VALUESETTYPE.PARTY_REQ_APPROVAL_STATUS_VSET
    //     ) {
    //       this.appStatus = {
    //         text: item.value_meaning,
    //         value: item.value_code
    //       };
    //     } 
    //   },
    //   clearFilters() {
    //     this.vendorName = null;
    //     this.accountNumber = null;
    //     this.appStatus = { value: null, text: null };
    //     this.bankName=null,
    //     this.updateBankData = [];
    //     this.totalRows = null;
    //     this.currentPage = 1;
    //   },
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
